<div class="ft-dropdown goal-incentives" [class.open]="open()" (click)="toggle($event)">
    <a class="ft-dropdown-toggle goal-name">
        <i class="icon icon-trophy"></i>
        <span [innerHTML]="getPropertyIncentive(incentive()) | incentiveName"></span>
        <i class="ft-icn-caret-down"></i>
    </a>
    <ul class="ft-dropdown-menu">
        @for (propertyIncentive of activeIncentives(); track propertyIncentive) {
            <li (click)="setIncentive(propertyIncentive)">
                <a [innerHTML]="propertyIncentive | incentiveName"></a>
            </li>
        }
    </ul>
</div>
